import { Skeleton } from '@/components/ui/skeleton'

export function SettingsPageSkeleton() {
  return (
    <div className="space-y-6">
      <header>
        <Skeleton className="h-8 w-48" />
      </header>

      <div className="flex flex-col gap-6 md:flex-row">
        <div className="shrink-0 md:w-56">
          <Skeleton className="h-10 w-full" />
        </div>
        <div className="min-w-0 flex-1 space-y-4">
          <Skeleton className="h-6 w-40" />
          <Skeleton className="h-4 w-full max-w-md" />
          <div className="flex gap-4">
            <Skeleton className="h-24 w-40" />
            <Skeleton className="h-24 w-40" />
          </div>
        </div>
      </div>
    </div>
  )
}
